import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { storage } from '@/utils/storage';

export default [
  {
    path: '/IFPageFiftyFivePreLogin',
    name: 'IFPageFiftyFivePreLogin',
    meta: {
      title: '星贷',
    },
    component: () => import('@/pages/pageListAll/pageFiftyFive/preLogin.vue'),
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 20230727 返回拦截下载页 */
      if (from.path === '/IFPageFiftyFiveLogin' || from.path === '/IFPageFiftyFiveLoginSecond') {
        window.history.back();
      } else {
        next();
      }
    },
  },
  {
    path: '/IFPageFiftyFiveLogin',
    name: 'pageFiftyFiveLogin',
    meta: {
      title: '星贷',
    },
    component: () => import('@/pages/pageListAll/pageFiftyFive/login.vue'),
  },
  {
    path: '/IFPageFiftyFiveLeaveInfo',
    name: 'pageFiftyFiveLeaveInfo',
    meta: {
      title: '星贷',
    },
    component: () => import('@/pages/pageListAll/pageFiftyFive/leaveInfo.vue'),
  },
  {
    path: '/IFPageFiftyFiveResult',
    name: 'pageFiftyFiveResult',
    meta: {
      title: '星贷',
    },
    component: () => import('@/pages/pageListAll/pageFiftyFive/result.vue'),
  },
  {
    path: '/IFPageFiftyFiveLoading',
    name: 'pageFiftyFiveLoading',
    component: () => import('@/pages/pageListAll/pageFiftyFive/loading.vue'),
    meta: {
      title: '额度检测',
    },
  },
  {
    path: '/IFPageFiftyFiveLoginSecond',
    name: 'pageFiftyFiveLoginSecond',
    component: () => import('@/pages/pageListAll/pageFiftyFive/loginSecond.vue'),
    meta: {
      title: '星贷',
    },
  },
  {
    path: '/IFPageFiftyFiveOnline',
    name: 'pageFiftyFiveOnline',
    component: () => import('@/pages/pageListAll/pageFiftyFive/online.vue'),
    meta: {
      title: '星贷',
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 网贷来源页 */
      if (from.path == '/IFPageFiftyFiveLoginSecond') {
        storage.setItem('onlineGoApply', null);
      } else {
        to.query.time = `${new Date().getTime()}`;
      }
      next();
    },
  },
  {
    path: '/IFPageFiftyFiveGuide',
    name: 'pageFiftyFiveLoginGuide',
    component: () => import('@/pages/pageListAll/pageFiftyFive/guide.vue'),
    meta: {
      title: '星贷',
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      to.query.formUrl = from.path;
      next();
    },
  },
  {
    path: '/IFPageFiftyFiveCar',
    name: 'pageFiftyFiveCar',
    component: () => import('@/pages/pageListAll/pageFiftyFive/car.vue'),
    meta: {
      title: '补充留资',
    },
  },
  {
    path: '/IFPageFiftyFiveBlank',
    name: 'pageFiftyFiveBlank',
    component: () => import('@/pages/pageListAll/pageFiftyFive/blank.vue'),
    meta: {
      title: '星贷',
    },
  },
  {
    path: '/IFPageFiftyFiveOnlineTab',
    name: 'pageFiftyFiveOnlineTab',
    component: () => import('@/pages/pageListAll/pageFiftyFive/onlineTab.vue'),
    meta: {
      title: '星贷',
    },
  },
];
